<div>
  <mat-toolbar color="primary">
    <div class="mobile-only">
      <mat-icon data-testid="toggle_menu_button" (click)='onToggleSidenav()'>menu</mat-icon>
    </div>
    @if (isAuthenticated()) {
      <mat-icon class="cursor" (click)="onToggleSidenav()">menu</mat-icon>
    }
    <a [href]="homeUrl"><mat-icon class="logo" svgIcon="logo"></mat-icon></a>
    @if (!isAuthenticated()) {
      <div class="desktop-only">
        <div i18n="@@home" data-testid="home_link" (click)="navigateTo('/home-script')" class="{{(routeName === '/home-script' || routeName === '/' ? 'mat-display-2 d-inline cursor nav-item active-link' : 'mat-display-2 d-inline cursor nav-item')}}">Home</div>
        <div i18n="@@salesScript" data-testid="sales_script_link" (click)="navigateTo('/sales-script')" class="{{(routeName === '/sales-script' ? 'mat-display-2 d-inline cursor nav-item active-link' : 'mat-display-2 d-inline cursor nav-item')}}">Sales Script</div>
        <div i18n="@@pricing" data-testid="pricing_link" (click)="navigateTo('/pricing')" class="{{(routeName === '/pricing' ? 'mat-display-2 d-inline cursor nav-item active-link' : 'mat-display-2 d-inline cursor nav-item')}}">Pricing</div>
        <div i18n="@@aboutUs" data-testid="about_link" (click)="navigateTo('/about')" class="{{(routeName === '/about' ? 'mat-display-2 d-inline cursor nav-item active-link' : 'mat-display-2 d-inline cursor nav-item')}}">About Us</div>
        <div i18n="@@contactUs" data-testid="contact_us_link" (click)="navigateTo('/contact-us')" class="{{(routeName === '/contact-us' ? 'mat-display-2 d-inline cursor nav-item active-link' : 'mat-display-2 d-inline cursor nav-item')}}">Contact Us</div>
      </div>
    }
    @if (!utils.isMobile() && !isAuthenticated()) {
      <button i18n="@@signIn" data-testid="signin_button" class="signin-button" (click)="openSignin()" mat-stroked-button>Sign In</button>
    }
    <div style="position: relative;" class="{{(isAuthenticated()? 'cursor signin-button' : 'cursor')}}">
      @if (isAuthenticated()) {
        <mat-icon [matBadge]="unreadCount" matBadgeSize="small" matBadgeColor="warn" [matBadgeHidden]="!showBadge" class="cursor signin-button notifications-badge" #toggleButton (click)="toggleNotification($event)" i18n-title title="Notifications">notifications</mat-icon>
      }
      @if (isNotificationOpen) {
        <div class="{{(notificationList.length > 5 ? 'menu' : 'short-menu')}}" #menu *ngIf="isNotificationOpen" id="notification-menu">
          @for (item of notificationList; track item; let itemIndex = $index) {
            <div class="{{item.isRead ? '' : 'unread-notification-box'}}" >
              @if (item.url) {
                <a  (click)="markAsRead(item.id)" href="{{item.url}}" target="_blank" class="notification-box">
                  <img src="{{utils.isDarkMode() ? '../../../assets/images/circle-notifications-dark.png' : '../../../assets/images/circle-notifications.png'}}">
                  @if (item.url) {
                    <a href="{{item.url}}" target="_blank">
                      <div class="mat-headline-5 mb-8">{{item.title}}</div>
                      <div class="mat-caption wrap" matTooltip ellipsisTooltip>{{item.description | slice:0:110}}{{item.description.length > 110 ? '...' : ''}}</div>
                    </a>
                  }
                </a>
              }
              @if (item.url === null) {
                <a (click)="markAsRead(item.id)" class="notification-box">
                  <img src="{{utils.isDarkMode() ? '../../../assets/images/circle-notifications-dark.png' : '../../../assets/images/circle-notifications.png'}}">
                  @if (item.url === null) {
                    <div  >
                      <div class="mat-headline-5 mb-8">{{item.title}}</div>
                      <div class="mat-caption wrap" matTooltip ellipsisTooltip>{{item.description | slice:0:110}}{{item.description.length > 110 ? '...' : ''}}</div>
                    </div>
                  }
                </a>
              }
              @if (item.url) {
                <a href="{{item.url}}" target="_blank">
                  <div class="mat-caption sent-date" matTooltip ellipsisTooltip>{{item.sentDate | dateAgo}}</div>
                </a>
              }
              @if (item.url === null) {
                <a class="notification-box">
                  <div class="mat-caption sent-date" matTooltip ellipsisTooltip>{{item.sentDate | dateAgo}}</div>
                </a>
              }
              <mat-divider class="divider"></mat-divider>
            </div>
          }
        </div>
      }
      @if (notificationList.length !== 0 && isNotificationOpen) {
        <div class="short-menu-mark top-{{notificationList.length}}">
          <a (click)="markAllRead()" i18n="@@markAllRead" class="mat-caption p-20" matTooltip ellipsisTooltip>Mark All as Read</a>
        </div>
      }
      @if (notificationList.length === 0 && isNotificationOpen) {
        <div class="short-menu">
          <div i18n="@@youDontHaveNotifications" class="mat-caption p-20" matTooltip ellipsisTooltip>You do not have any notifications!</div>
        </div>
      }

    </div>
    <mat-menu #menu="matMenu">
      <button i18n="@@profile" data-testid="profile_button" mat-menu-item (click)="navigateTo('/profile')">Profile</button>
      <button i18n="@@logout" data-testid="logout_button" mat-menu-item (click)="authService.logout()">Logout</button>
    </mat-menu>
    @if (isAuthenticated()) {
      <div class="mat-headline-3 user-name">{{firstName}} {{lastName}}</div>
    }
    @if (isAuthenticated()) {
      <img [matMenuTriggerFor]="menu" class="profile-img cursor" src="{{profileImage}}" onerror="this.src='../../../assets/images/avatar.png'">
    }

    <button
      mat-stroked-button
      [matMenuTriggerFor]="langMenu"
      class="translate-button"
    >
      <mat-icon class="globe-icon">language</mat-icon>
      <span class="lang-text">
        {{ getLanguageDisplayName() }}
      </span>
      <mat-icon class="arrow-icon">expand_more</mat-icon>
    </button>

    <mat-menu #langMenu="matMenu" xPosition="after">
      <button mat-menu-item (click)="switchLanguage('en')">
        English
      </button>

      <button mat-menu-item (click)="switchLanguage('ar')">
        العربية
      </button>
    </mat-menu>

    <mat-slide-toggle
      data-testid="switch_theme_button"
      [checked]="isDarkMode"
      (change)="onDarkModeSwitched($event)"
      i18n-label
      label="Dark Mode"
    >Dark Mode</mat-slide-toggle>
  </mat-toolbar>
</div>

<button style="display: none;" id="checkBadge" i18n-title title="Profile">Profile</button>